import { createSlice } from "@reduxjs/toolkit";
import { getMyRanking, getMyWeeklyRanking, getOverallRanking } from "../../api/rankingService";

const rankingSlice = createSlice({
	name: "Ranking",
	initialState: {
		overallRanking: [],
		myRanking: [],
		myWeeklyRanking: [],
		roundRanking: [],
	},
	reducers: {
		setRanking(state, action) {
			state.overallRanking = action.payload;
		},
		setMyRanking(state, action) {
			state.myRanking = action.payload;
		},
		setMyWeeklyRanking(state, action) {
			state.myWeeklyRanking = action.payload;
		},
		setRoundRanking(state, action) {
			state.roundRanking = action.payload;
		},
	},
});

export const { setRanking, setMyRanking, setMyWeeklyRanking, setRoundRanking } = rankingSlice.actions;

export const getRankingRequest = (fansUnitedSDK) => async (dispatch) => {
	try {
		const rankingResponse = await getOverallRanking(fansUnitedSDK);
		if (!rankingResponse.data) return;

		dispatch(setRanking(rankingResponse.data));
	} catch (error) {
		throw error;
	}
};

export const getMyRankingRequest = (fansUnitedSDK) => async (dispatch) => {
	try {
		const rankingResponse = await getMyRanking(fansUnitedSDK);
		if (!rankingResponse.data) return;

		dispatch(setMyRanking(rankingResponse.data));
	} catch (error) {
		throw error;
	}
};

export const getMyWeeklyRankingRequest = (fansUnitedSDK, groupId, userId) => async (dispatch) => {
	try {
		const rankingResponse = await getMyWeeklyRanking(fansUnitedSDK, groupId, userId);

		if (!rankingResponse.data) {
			return;
		}

		dispatch(setMyWeeklyRanking(rankingResponse.data));
	} catch (error) {
		throw error;
	}
};

export const getRoundRankingRequest = (fansUnitedSDK, groupId) => async (dispatch) => {
	try {
		const { getRoundRanking } = await import("../../api/rankingService");
		const rankingResponse = await getRoundRanking(fansUnitedSDK, groupId);
		if (!rankingResponse.data) return;

		dispatch(setRoundRanking(rankingResponse.data));
	} catch (error) {
		throw error;
	}
};

export default rankingSlice.reducer;
